import * as env from 'env-var'

export default {
    buddy: env.get('REACT_APP_LINKS_BUDDY').required().asUrlString(),
}
